export const formatBaleDimensions = ({
  height,
  width,
  length,
}: {
  height?: number | null;
  width?: number | null;
  length?: number | null;
}) => {
  if (!height || !width || !length) {
    return null;
  }
  return `${height} x ${width} x ${length}`;
};
